import { AlertableSignalFlowDTO, AlertableSignalFlowInput } from '@atlassiansox/phobos-client-ts';

import { ENDPOINTS } from '@/meta';
import { apiFetch } from '@/services';
import { SignalFlowValidateResultType } from '@/controllers';

// ensure a number has 2 or less digits before the decimal place
// and 4 or less digits after
const validNumberOfDigits = (value: number): boolean => {
  const ValueMaxDigits = new RegExp(/^\d{1,2}(\.\d{1,4})?$/);
  return ValueMaxDigits.test(value.toString());
};

// note that "" is passed in for number input fields that do not contain strings
// parseable as a number
export const validateSLOTarget = (value?: '' | number) => {
  if (value === undefined || value === '') {
    return 'Number value is required';
  }

  if (value <= 0) {
    return 'Number must be greater than 0.';
  }

  if (value > 99.9999) {
    return 'Number must be less than or equal to 99.9999.';
  }

  if (!validNumberOfDigits(value)) {
    return 'Number must have a maximum of 2 digits before the decimal point and 4 after it.';
  }

  return undefined;
};

// SFx query validation related utils
export const SIGNALFLOW_ALERTABLE_ERROR = 'signalflow-alertable-error';
export const SIGNALFLOW_DATA_EMPTY_ERROR = 'signalflow-data-empty-error';

const mapValidateResultToErrorResult = (
  res: AlertableSignalFlowDTO
): SignalFlowValidateResultType => {
  if (!res) {
    return undefined;
  }

  const signalFlowValidateResult: SignalFlowValidateResultType = { ...res };

  if (!res.goodQueryErrors.length && !res.badQueryErrors.length && res.errors?.length) {
    signalFlowValidateResult.generalErrors = [...res.errors];
  }

  return signalFlowValidateResult;
};

export const fetchSignalFlowAlertable = async (
  payload: AlertableSignalFlowInput
): Promise<SignalFlowValidateResultType> => {
  const json: AlertableSignalFlowDTO = await apiFetch(ENDPOINTS.SIGNALFLOW, {
    method: 'POST',
    body: JSON.stringify(payload),
    headers: { 'Content-Type': 'application/json' },
  });
  const result: SignalFlowValidateResultType = mapValidateResultToErrorResult(json);
  return result;
};

export const isSignalFlowValidated = (result: SignalFlowValidateResultType): boolean => {
  if (!result) {
    return true;
  }

  const { goodQueryErrors, badQueryErrors, generalErrors } = result;
  return !(goodQueryErrors?.length || badQueryErrors?.length || generalErrors?.length);
};
